
import { list_type, tuple_type, obj_type, string_type, class_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ofNullable, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Auto_generateBoxedDecoder_Z6670B51, fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { disposeSafe, getEnumerator, Exception, uncurry2 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { addToDict } from "../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { empty as empty_1, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";

export class swrConfig {
    constructor() {
    }
}

export function swrConfig_$reflection() {
    return class_type("Fable.Import.SWR.swrConfig", undefined, swrConfig);
}

function isPersisted(key) {
    return !(((key.startsWith("/api/telematics") ? true : key.endsWith("/trackers")) ? true : (key === "/api/inventory-states")) ? true : (key === "/api/dashboard"));
}

export function localStorageProvider(_arg) {
    const data = defaultArg(map_1((json) => {
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(list_type(tuple_type(string_type, obj_type)), undefined, undefined)), json);
        if (matchValue.tag === 1) {
            throw new Exception(matchValue.fields[0]);
        }
        else {
            return matchValue.fields[0];
        }
    }, ofNullable(localStorage.getItem("app-cache"))), empty());
    const map = new Map([]);
    const enumerator = getEnumerator(data);
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            const key = forLoopVar[0];
            if (isPersisted(key)) {
                addToDict(map, key, forLoopVar[1]);
            }
        }
    }
    finally {
        disposeSafe(enumerator);
    }
    window.addEventListener("beforeunload", (_arg_1) => {
        const matchValue_1 = ofNullable(localStorage.getItem("mwk_skip_cache_persist"));
        if (matchValue_1 == null) {
            const convertedMap = toList(delay(() => collect((element) => (isPersisted(element[0]) ? singleton([element[0], element[1]]) : empty_1()), map)));
            const data_1 = toString(0, Auto_generateBoxedEncoder_437914C6(list_type(tuple_type(string_type, obj_type)), undefined, undefined, undefined)(convertedMap));
            localStorage.setItem("app-cache", data_1);
        }
        else {
            localStorage.removeItem("mwk_skip_cache_persist");
            localStorage.removeItem("app-cache");
        }
    });
    return map;
}

